import DiscardChangesConfirmModal from './DiscardChangesConfirmModal';

export default DiscardChangesConfirmModal;
